import {useRouteLang} from "src/hooks/use-route-lang";


export default function Wishlist() {
  const lang = useRouteLang();

  return (
      <>
        {/*<Wishlist lang={lang}/>*/}
      </>
  );
}
